import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import LinkAccountsLoginPage from './LinkAccountsLoginPage';
import {
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    clearAuthNotification as clearAuthNotificationAction,
    forceStld as forceStldAction,
    sendEmailLinkAccount as sendEmailLinkAccountAction,
    viewPassword as viewPasswordAction,
} from '../../actions/auth';

const _mapStateToProps = ({ authentication }) => ({
    email: authentication.email,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    disableRecaptcha3: authentication.disableRecaptcha3,
    socialData: authentication.socialData,
});

const _mapDispatchToProps = {
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
    moveBack: moveBackAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    handleClickViewPassword: viewPasswordAction,
    clearAuthNotification: clearAuthNotificationAction,
    onForceStld: forceStldAction,
    handleSendMailLinkAccount: sendEmailLinkAccountAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(LinkAccountsLoginPage),
);
